import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddRedirection, UpdateRedirection } from './redirection.interface';

@Injectable({
    providedIn: 'root',
})
export class RedirectionService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.adreseRedirect.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.adreseRedirect.listDT;

    private findURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.adreseRedirect.find;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.adreseRedirect.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.adreseRedirect.update;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.adreseRedirect.delete;

    // private listActiveUrl =
    //     this.basePath +
    //     environment.interop.indoc.nomenclatoare.registratura.adreseRedirect
    //         .listActive;

    // private listPublicUrl =
    //     this.basePath +
    //     environment.interop.indoc.nomenclatoare.registratura.adreseRedirect
    //         .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.adreseRedirect
            .active;

    // private changeStatusPublicUrl =
    //     this.basePath +
    //     environment.interop.indoc.nomenclatoare.registratura.adreseRedirect
    //         .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    list() {
        return this.http.get(this.listUrl, this.httpOptions);
    }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddRedirection) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: UpdateRedirection) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.get(this.changeStatusActiveUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
